<div id="layoutContainer" #subscriberDiv></div>
<a id="lnkClose" class="grid-link" (click)="closeVideo()">
    <img class="video-close-cs" src="../../assets/call-disconnect.png" alt="image" />
</a>